import clsx from "clsx";
import { motion } from "framer-motion";
import { MetricHeader } from "./MetricHeader";
import { SidebarPortal } from "@/features/Navigation/components/SidebarPortal";
import { MetricList } from "./MetricList";
import { showCompanyListAtom } from "../CompaniesLayout";
import { useAtom } from "jotai";
import { selectedPeriodAtom } from "./metrics.state";
import { RightDrawerContent } from "@/features/Navigation/components/RightDrawerContent";
import { LineagedValuePanel } from "./LineagedValuePanel";
import { rightDrawerOpenAtom } from "@/features/Navigation/state";
import { useEffect } from "react";
import { MetricTable } from "./components/MetricTable";
import { MetricListHeader } from "./components/MetricListHeader";

export default function MetricsPage() {
    const [showCompanyList] = useAtom(showCompanyListAtom);
    const [rightDrawerOpen, setRightDrawerOpen] = useAtom(rightDrawerOpenAtom);
    const [selectedPeriod, setSelectedPeriod] = useAtom(selectedPeriodAtom);

    useEffect(() => {
        if (rightDrawerOpen && !selectedPeriod) {
            setRightDrawerOpen(false);
        }
    }, [rightDrawerOpen, selectedPeriod, setRightDrawerOpen]);

    return (
        <>
            <div>
                {!showCompanyList && (
                    <SidebarPortal>
                        <MetricListHeader />
                        <MetricList />
                    </SidebarPortal>
                )}

                {selectedPeriod && (
                    <RightDrawerContent onClose={() => setSelectedPeriod(null)}>
                        <LineagedValuePanel />
                    </RightDrawerContent>
                )}
            </div>
            <motion.div className="flex size-full">
                <div
                    className={clsx("size-full px-6", "flex flex-col", "gap-3")}
                >
                    <MetricHeader />
                    <MetricTable />
                </div>
            </motion.div>
        </>
    );
}
